export enum NavigationContextActionType {
  FlushFolderSpaceInfo = 'flushFolderSpaceInfo',
  FlushMissionSpaceInfo = 'flushMissionSpaceInfo',
  SetFolderSpaceInfo = 'setFolderSpaceInfo',
  SetMissionSpaceInfo = 'setMissionSpaceInfo',
  SetPage = 'setPage',
}
